import Icon from '../../common/components/Icon';
import React from 'react';

export interface ChipProps {
  name: string;
  type: 'filled' | 'outline';
  color: 'amber' | 'blue' | 'stone' | 'slate' | 'emerald';
  iconName?: string;
}

const Chip: React.FC<ChipProps> = ({ name = '', type, color, iconName }) => {
  return (
    <div className={`chip ${type} chip--${color}`}>
      {name && (
        <div className="chip__wrapper">
          {iconName && <Icon name={iconName} size="small" />}
          <label className="chip__label">{name}</label>
        </div>
      )}
    </div>
  );
};

export default Chip;
